<template>

<div v-if="isVisible" class="user-caller-form">
<!---
<h4 class="alert alert-warning text-center" style="margin-top: 0px; padding: 5px;">{{getInfoText}}</h4>
-->

<fieldset enabled>
 
  <form 
    style=""
    class="form-horizontal user-caller-form"
    form @keyup.esc="onClickCancel"
    @submit.prevent="onClickSave"
    :id="_uid">

    <!-- Herr / Frau / Title -->
    <div class="form-group" >
      
      <label class="col-sm-2 control-label " for="sex" style="color: #aaa">{{getInfoText}}:</label>
      <div class="col-sm-4">
        <div class="btn-group" data-toggle="buttons">
          <label class="btn btn-default" v-on:click="caller.idSex = 1" v-bind:class="{ 'cc-required': caller.idSex == 0 , active: caller.idSex == 1 }"> Herr </label>
          <label class="btn btn-default" v-on:click="caller.idSex = 2" v-bind:class="{ 'cc-required': caller.idSex == 0 , active: caller.idSex == 2 }"> Frau </label>
        </div>
      </div>

    <!-- Title -->
      <div class="col-sm-2">
         <select class="form-control" v-model="caller.idPertitel">
            <option v-for="option in UserConf.PERTITEL" 
              :value="option.VALUE">
              {{ option.TEXT }}
            </option>
          </select>
      </div>
      
      <div class="col-sm-3">
        <input type="text" class="form-control" id="customer-number" placeholder="Kundennummer" v-model="caller.customerNumber">
      </div>

      
    </div>


    <!-- firstName lastName -->
    <div class="row form-group">
      <label class="col-sm-2 control-label " for="last-name">Nachname:</label>
      <div class="col-sm-4">
        <div class="input-group" data-toggle="buttons">
          <input v-focus type="text" class="form-control" id="last-name" placeholder="Nachname" v-model="caller.lastName" required>
          <span class="input-group-btn">
          <button type="button" v-on:click="toggleFirstLastName" class="btn btn-primary xxform-control" title="tausche Nachname Vorname">
            <span class="glyphicon glyphicon-transfer" aria-hidden="true"></span>
          </button>
          </span>
        </div>
      </div>
      
      <label class="col-sm-2 control-label" for="first-name">Vorname:</label>
      <div class="col-sm-3">
        <input type="text" class="form-control" id="first-name" placeholder="Vorname" v-model="caller.firstName" >
      </div>
      <div class="col-sm-1 text-right">
       <button type="button" class="btn btn-sm btn-primary xxform-control" data-toggle="collapse" data-target="#caller-adresse" title="Anrufer Adresse">
         <span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span></button>
      </div>
    </div>

    <!-- Caller Adress -->
    <div id="caller-adresse" class="collapse">
      <div class="row form-group">
        <label class="col-sm-2 control-label" for="caller-street">Straße:</label>
        <div class="col-sm-4">
          <input type="text" class="form-control" id="caller-street" placeholder="Straße" v-model="caller.street">
        </div>
        <label class="col-sm-2 control-label" for="caller-street-number">Hausnummer:</label>
        <div class="col-sm-3">
          <input type="text" class="form-control" id="caller-street-number" placeholder="Hausnummer" v-model="caller.streetNumber">
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-2 control-label" for="plz">PLZ:</label>
        <div class="col-sm-4">
          <div class="input-group">
            <div class="input-group-btn">
              <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">DE <span class="caret"></span></button>
              <ul class="dropdown-menu">
                <li><a href="#">D</a></li>
                <li><a href="#">AT</a></li>
                <li><a href="#">CH</a></li>
                <li><a href="#">RU</a></li>
              </ul>
            </div>
            <input type="number" min="1000" max="99999" class="form-control" id="zip-code" placeholder="PLZ" v-model="caller.zipCode">
          </div>
        </div>
        <label class="control-label col-sm-2" for="ort">Ort:</label>
        <div class="col-sm-3">
          <input type="text" class="form-control" id="caller-city" placeholder="Ort" v-model="caller.city">
        </div>
      </div>
    </div>
      
    <!-- VIP /Info -->
    <div class="form-group">
      <label class="col-sm-2 control-label" for="nachname">VIP:</label>
      <div class="col-sm-9">
        <input type="text" class="form-control" id="caller-info" placeholder="Besondere Hinweise zum Anrufer" v-model="caller.info">
      </div>
    </div>

    <!-- Company / CusomerNumber -->
    <!--
    <div class="form-group">
      <label class="col-sm-2 control-label" for="company-name">Firma:</label>
      <div class="col-sm-4">
        <input type="text" class="form-control" id="company-name" placeholder="Firmennamen" v-model="caller.company.name">
      </div>
      <label class="col-sm-2 control-label" for="customer-number">Kd.Nummer:</label>
      <div class="col-sm-3">
        <input type="text" class="form-control" id="customer-number" placeholder="Kundennummer" v-model="caller.customerNumber">
      </div>
      <div class="col-sm-1 text-right">
        <button type="button" class="btn btn-primary xxform-control" data-toggle="collapse" data-target="#company-adress" title="Firmen Adresse">
          <span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span>
        </button>
      </div>
    </div>
    -->

         
    
    <!-- Fima -->  
    <div>

     <!-- Firma anzeigen -->
     <div v-show="caller.idCompany > 0" class="form-group">
      <label class="col-sm-2  control-label" >Firma:</label>
      <div class="col-sm-9">
         <div class="form-control-static">
          <strong>{{caller.company.name}}</strong>
           - <small>{{caller.company.street}}</small>
           <small>{{caller.company.streetNumber}},</small>
           <small>{{caller.company.zipCode}}</small>
           <small>{{caller.company.city}}</small>
           <!-- <i class="fa fa-pencil" title="Firma bearbeiten"></i> -->
        </div>
      </div>
      <div class="col-sm-1 text-right">
        <button type="button" class="btn btn-sm btn-primary xxform-control" data-toggle="collapse" data-target="#company-adress" title="Firmenzuordnung aufheben" v-on:click="resetCallerCompany">
         <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
        </button>
      </div>
    </div>
    
      <!-- Firma auswählen -->
     <div v-show="caller.idCompany == 0 && caller.company.name == ''" class="form-group">
      <label class="col-sm-2  control-label" >Firma:</label>
      <div class="col-sm-9">
        <company-caller-typeahead v-show="!caller.company.id"></company-caller-typeahead>
      </div>
    </div>
      
     <!-- Firma Formular -->
    <div v-show="caller.idCompany == 0 && caller.company.name" >
     <div class="form-group">
      <label class="col-sm-2 control-label" for="company-name">Neue Firma:</label>
      <div class="col-sm-9">
       <div class="input-group" data-toggle="buttons">

        <input type="text" class="form-control" id="company-name" placeholder="Firmennamen" v-model="caller.company.name">
        <span class="input-group-btn">
          <button type="button" v-on:click="resetCallerCompany" class="btn btn-default form-control" title="lösche inhalt">
            <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
          </button>
        </span>
      </div>
      </div>
      <div class="col-sm-1 text-right">
        <button type="button" class="btn btn-sm btn-primary xxform-control" data-toggle="collapse" data-target="#company-adress" title="Firmen Adresse">
          <span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span>
        </button>
      </div>
    </div>
      
      <!-- Company Adresse -->
      <div id="company-adress" class="collapse">
        <div class="form-group">
          <label class="control-label col-sm-2" for="company-street">Straße:</label>
          <div class="col-sm-4">
            <input type="text" class="form-control" id="company-street" placeholder="der Firma" v-model="caller.company.street">
          </div>
          <label class="control-label col-sm-2" for="company-street-number">Hausnummer:</label>
          <div class="col-sm-3">
            <input type="text" class="form-control" id="company-street-number" placeholder="der Firma" v-model="caller.company.streetNumber">
          </div>
        </div>

        <div class="form-group">
          <label class="control-label col-sm-2" for="company-zip-code">PLZ:</label>
          <div class="col-sm-4">
            <input type="text" class="form-control" id="company-zip-code" placeholder="der Firma" v-model="caller.company.zipCode"> 
          </div>
          <label class="control-label col-sm-2" for="company-city">Ort:</label>
          <div class="col-sm-3">
            <input type="text" class="form-control" id="company-city" placeholder="der Firma" v-model="caller.company.city">
          </div>
        </div>
      </div>
    </div> 
      
  </div>
    
    

    
    <!-- Komboxen -->
    <div class="cc-kombox-items">
      <div class="" v-for="kombox in caller.komboxes">
        <div v-show="kombox.datetimeEnd" class="row cc-kombox-item">
          <div class="col-sm-2 text-right" style="padding-right: 0px">
           <select class="form-control text-right" v-model="kombox.type">
              <option v-for="option in KomboxConf.TYPES_USERCALLER" 
                :value="option.OPTION.VALUE">
                {{ option.OPTION.TEXT }}
              </option>
            </select>
          </div>
          <div class="col-sm-5" style="padding: 0px">
          <input 
            class="form-control"
            type="text"
            :pattern="KomboxConf.TYPES[kombox.type].CONTENT.PATTERN"
            :placeholder="KomboxConf.TYPES[kombox.type].CONTENT.PLACEHOLDER"
            :title="KomboxConf.TYPES[kombox.type].CONTENT.PLACEHOLDER"
            v-model="kombox.content" >
          </div>
          <div class="col-sm-4" style="padding-left: 0px">
            <input type="text" class="form-control" placeholder="privat, office ..." v-model="kombox.description" >
          </div>
          <div class="col-sm-1 text-right" >
            <button
              type="button"
              class="btn btn-sm btn-primary" 
              title="löschen" 
              @click="kombox.datetimeEnd = '', kombox.content = ''">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </div>
          
          
        </div>
      </div>
   </div>
       
        

    
    <div class="row" style="margin-top:7px">
      <div class="col-sm-11">
       <div class="text-center">
          <button 
            type="submit"
            :form="_uid" 
            class="btn cc-attention">
            Speichern
          </button>
        
          <button 
            type="button" class="btn " 
            v-on:click="onClickCancel">
            Abbrechen
          </button>
        </div>
      </div>
      <div class="col-sm-1 text-right">
       <button type="button" class="btn btn-sm btn-primary xxform-control" v-on:click="onClickAddKombox" >
        <i class="fa fa-plus" aria-hidden="true"></i>
       </button>
      </div>
    </div>

  </form>

</fieldset>



</div>            
</template>



<script>

import KomboxUserCaller from './KomboxUserCaller.vue'
import CompanyCallerTypeahead from './CompanyCallerTypeahead.vue'
import bus from './common/bus'
import * as KomboxConf from './common/kombox.conf'
import * as UserConf from './common/user.conf'

export default {
    
  components: {
    'company-caller-typeahead': CompanyCallerTypeahead,
    'cc-kombox-usercaller': KomboxUserCaller,
  },
  
  data () {
    return {
      
      KomboxConf: KomboxConf,
      UserConf: UserConf,
      
      modelCaller:{
        id: false,
        idSex: '0',
        idPertitel: '0',
        firstName: '',
        lastName: '',
        info: '',
        idCountry: '',
        zipCode: '',
        street: '',
        streetNumber: '',
        customerNumber: '',
        function: '',
        city: '',
        validity: '',      
        idCompany: '0',
        idCompanyContact: '',
        company:{},
        komboxes:[],
      },

      modelCompany:{
        id: 0,
        idCompanyContact: '',
        name: '',
        idCountry: '',
        zipCode: '',
        city: '',
        street: '',
        streetNumber: '',
      },
      
      pertitel: {},
      caller: {},
    }
  },
  
  created: function () {
    bus.registerOnIdUserCaller(this.onIdUserCaller);
    bus.registerOnNewUserCaller(this.onNewUserCaller);
    bus.registerOnEditUserCaller(this.onEditUserCaller);
    bus.registerOnCloneUserCaller(this.onCloneUserCaller);
    
    bus.registerOnCompanyCaller(this.onCompanyCaller);
    bus.registerOnIdCompanyClient(this.reset); // Rest if new Company Client
    bus.registerOnNewCompanyCaller(this.onNewCompanyCaller);
    this.reset();
  },
  
  computed: {
    isVisible: function () {
      return  !!this.caller.idCompanyContact
      //return  !!this.caller.lastName.length;
    },
    
    getInfoText: function () {
      if(!!this.caller.id){
        return  "Ändern";
      }else{
        return  "Neu";
      }
      
    },
    
  },
  
  watch: {
    pertitel: function (val) {
      this.caller.idPertitel = val.id;
    },
  },
  
  methods: {

    /* neue Firma über Typahead ausgewählt */
    onCompanyCaller: function (companyCaller, event, call) {

      this.caller.idCompany = companyCaller.id;
      this.caller.company = companyCaller;
    },

    /* nicht gefundenen Firma über Typahead anlegen */
    onNewCompanyCaller: function (companyName, event, call) {
      // Reset Company
      this.resetCallerCompany();
      // Set company name
      this.caller.company.name = companyName;
      this.caller.company.idCompanyContact = call.idCompanyClient;
    },

    onIdUserCaller: function (idUserCaller, event, call) {
            console.log('onIdUserCaller: ' + idUserCaller);

      this.reset();
      // TODO das muss für das bearbeiten noch anders werde...
      this.caller.id = idUserCaller;
    },
      
    onNewUserCaller: function (name, event, call) {
      this.reset();
      
      // Schon mal zwei Komboxen anbieten
      this.caller.komboxes = [
        this.getModelKombox(0),
        this.getModelKombox(1),
      ];

      if(typeof name == 'string'){
        name = name.split(" ");
        this.caller.lastName = _.upperFirst(name[0]);
        this.caller.firstName = _.upperFirst(name[1]);
        this.caller.idCompanyContact = call.idCompanyClient;
      }
      if(typeof this.caller.firstName == 'undefined'){
        this.caller.firstName = '';
      }
      
    },

    onEditUserCaller: function (userCaller, event, call) {
      //this.reset();
      this.caller = userCaller;
      if(!this.caller.komboxes.length){
        // Wenn keine Komboxen vorhanden dann schon mal zwei anbieten
        this.caller.komboxes = [
          this.getModelKombox(0),
          this.getModelKombox(1),
        ];
      }
      //console.log('UserCallerForm:onEditUserCaller:' + JSON.stringify(userCaller, null, 2));
      
    },

    onCloneUserCaller: function (userCaller, event, call) {
      this.reset();
      userCaller.id = 0;
      this.caller = userCaller;
    },
    
    // Komboxen

    getModelKombox: function (type = 0) {
      var kombox = _.clone(KomboxConf.DEFAULT_OBJECT);
      //var kombox = JSON.parse(JSON.stringify(this.modelKombox()));
      kombox.type = type;
      return kombox;
    },

    onClickAddKombox: function () {
      this.caller.komboxes.push(this.getModelKombox(1));
    },

    onClickSave: function () {
      if(this.caller.idSex == 0){
        $( ".user-caller-form .cc-required" ).addClass( "btn-danger" );
      }else{
        if(this.caller.idCompany == bus.call.idCompanyClient){
          // es ist ein Mitarbeiter
          this.caller.idCompanyContact = this.caller.idCompany;
          this.saveUserClient();
        }else{
          // es ist ein Anrufer
          this.saveUserCaller();
        }
        
      }
      /*
      if(this.caller.id == false){
        this.insertUserCaller();
      }else{
        this.updateUserCaller(this.caller.id);
      }
      */
    },

    onClickCancel: function () {
      bus.emitIdUserCaller(this.caller.id);
      this.reset();
      bus.emitCompanyCaller(this.caller.company);
    },
    
    resetCallerCompany: function () {
      this.caller.idCompany = 0;
      this.caller.company = JSON.parse(JSON.stringify(this.modelCompany));
        
    },
    
    reset: function () {
      this.pertitel = {id: '0'},
      this.caller = JSON.parse(JSON.stringify(this.modelCaller));
      this.caller.company = JSON.parse(JSON.stringify(this.modelCompany));
    },
    
    toggleFirstLastName: function () {
      let firstName; 
      firstName = this.caller.firstName;
      this.caller.firstName = this.caller.lastName;
      this.caller.lastName = firstName;
    },
    
    loadUserCaller: function (idUserCaller) {
      this.$http.get(bus.config.path + '/user/caller/' + idUserCaller).then((response) => {
        this.caller = response.data;

      }, (response) => {
      // error callback
      });
    },

    saveUserCaller: function () {
      this.$http.post(bus.config.path + '/user/caller', this.caller).then((response) => {
        // TODO Optimierung wenn der kommplette Rückgabewert versendet wird
        bus.emitIdUserCaller(response.data.id);
        //console.log('UserCallerForm:saveUserCaller:' + JSON.stringify(response.data, null, 2));

        this.reset();
      }, (response) => {
      // error callback
      });
    },

    saveUserClient: function () {
      this.$http.post(bus.config.path + '/user/client', this.caller).then((response) => {
        // TODO Optimierung wenn der kommplette Rückgabewert versendet wird
        bus.emitIdUserCaller(response.data.id);
        //console.log('UserCallerForm:saveUserCaller:' + JSON.stringify(response.data, null, 2));

        this.reset();
      }, (response) => {
      // error callback
      });
    },

/*    
    updateUserCaller: function (idUserCaller) {
      this.$http.put(bus.config.path + '/user/caller/' + idUserCaller, this.caller).then((response) => {
        // TODO Optimierung wenn der kommplette Rückgabewert versendet wird
        bus.emitIdUserCaller(response.data.id);
        this.reset();

      }, (response) => {
      // error callback
      });
    },
*/    
  }
  
}
</script>



<style scoped>
  
 .row{
    margin-right: 0px;
    margin-left: 0px;
    padding-right: 0px;
    padding-left: 0px;
   
  }  
  
input:invalid, .cc-required {
  border: 1px solid red;
}

  
.cc-attention{
    background-color: #f9f7c0;
}
  
.cc-kombox-items{
    margin-top: 20px;
  }
  
.cc-kombox-item{
    border-top: 0px solid lightgrey;
    padding-top: 0px;
    padding-bottom: 6px;
  
}  
  
  .user-caller-form{
    padding-bottom: 15px;
    margin-bottom: 15px;
    margin-top: 5px;
    border-bottom: 0px solid lightgrey;
    border-left: 5px solid #f9f7c0;
  }
 
  .form-horizontal .form-group {
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 6px;
}
  
</style>



// WEBPACK FOOTER //
// UserCallerForm.vue?bccd4728